import { __assign, __read, __spread } from "tslib";
import * as actionTypes from '../constants/actionTypes';
import * as status from '../constants/replay';
var initialState = {
    events: [],
    status: status.STOPPED,
    cursorCoords: [0, 0],
    clicks: [],
    currentEventIndex: 0,
    goalScreenPk: null,
};
export default function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.REPLAY_START_RECORDING:
            return __assign(__assign({}, state), { status: status.RECORDING, goalScreenPk: action.goalScreenPk });
        case actionTypes.REPLAY_STOP_PLAYING:
        case actionTypes.REPLAY_STOP_RECORDING:
            return __assign(__assign({}, state), { status: status.STOPPED });
        case actionTypes.REPLAY_START_PLAYING:
            return __assign(__assign({}, state), { status: status.PLAYING, events: action.events });
        case actionTypes.REPLAY_ON_EVENT:
            return __assign(__assign({}, state), { currentEventIndex: action.eventIndex });
        case actionTypes.REPLAY_SET_CURSOR_POSITION:
            return __assign(__assign({}, state), { cursorCoords: action.coords });
        case actionTypes.REPLAY_CLICK_START: {
            var id = action.id, coords = action.coords, isMiss = action.isMiss;
            return __assign(__assign({}, state), { clicks: __spread(state.clicks, [{ id: id, coords: coords, isMiss: isMiss }]) });
        }
        case actionTypes.REPLAY_CLICK_END:
            return __assign(__assign({}, state), { clicks: state.clicks.filter(function (click) { return click.id === action.id; }) });
        case actionTypes.REPLAY_SET_CURRENT_EVENT:
            return __assign(__assign({}, state), { currentEventIndex: action.eventIndex, startWallTime: action.startWallTime, wallTime: action.wallTime, startTime: action.startTime });
        case actionTypes.REPLAY_ENDED:
            return __assign(__assign({}, state), { currentEventIndex: 0, status: status.STOPPED, clicks: [] });
        default:
            return state;
    }
}
